import Cookies from "js-cookie";
import config from "../config";

/**
 * Replaces parameters in url noted by :parameter by the equivalent property in the parameters object
 * e.g: urlFormat('v1/api/:id' ,{ id: 1 }) returns 'v1/api/1'
 * @param {string} url
 * @param {object} parameters
 * @returns url with :params replaced by values in parameter
 */
export const urlFormat = (url, parameters) => {
  if (parameters !== undefined) {
    //replace :parameter with value defined in object.
    url = url.replace(/:([a-zA-Z0-9_]+)/g, function (_, v) {
      return encodeURIComponent(parameters[v] || "");
    });
  }

  url = config.apiUrl + url.replace(/^\//, "");
  return url;
};

export const getHeaders = (bodyAsJson) => {
  let headers = {
    ...getAuthorizationHeader(),
    ...getAcceptLanguageHeader(),
  };
  if (bodyAsJson) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
};

const getAcceptLanguageHeader = () => {
  return {
    "Accept-Language": config.culture,
  };
};

const getAuthorizationHeader = () => {
  let token = Cookies.get("apiToken");
  refreshTokenIfHalfLifetimeHasPassed(token);

  return {
    Authorization: token,
  };
};

export const getJsonOrDefault = (text) => {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};

/**
 * Refreshes the api session(apiToken cookie), refreshing the lifelength to the value set by configuration
 */
export const refreshApiCookie = async () => {
  let token = Cookies.get("apiToken");
  const headers = { ...getAcceptLanguageHeader(), Authorization: token };

  let baseUrl = config.apiUrl || "";
  await fetch(baseUrl + "v1/users/refreshToken", {
    method: "POST",
    headers,
    body: "",
  })
    .then((response) => response.text())
    .then((data) => getJsonOrDefault(data))
    .then((body) => {
      const expiration = new Date(/LoginToken_(.*?)_/g.exec(body)[1]);
      Cookies.set("apiToken", body, {
        expires: expiration,
        secure: true,
        sameSite: "Strict",
      });
    })
    .catch(() => {
      logOut();
    });
};

const refreshTokenIfHalfLifetimeHasPassed = (token) => {
  if (!token || token === "example-token-1") {
    logOut();
  } else {
    let sTimer = Number(Cookies.get("sessionTimeout") || "1") || 1;
    let result = /LoginToken_(.*?)_/g.exec(token);
    let guidResult =
      /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g.exec(
        token,
      );
    if (result) {
      let expirationDate = new Date(result[1]);
      let now = new Date();

      if (expirationDate - now < (sTimer / 2) * 60 * 1000) {
        // Token is expiring soon, fetch new token "in the background" for future requests
        refreshApiCookie();
        refreshPortalCookie();
      }
    } else if (guidResult) {
      // do nothing
    } else {
      logOut();
    }
  }
};

/**
 * Refreshes the portal session(lp2004b cookie), refreshing the lifelength to the value set by configuration
 */
export const refreshPortalCookie = async () => {
  let token = Cookies.get("apiToken");
  const headers = { ...getAcceptLanguageHeader(), Authorization: token };
  const portalUrl = config.urlRoot || "/luvitportal/";
  await fetch(
    `${
      window.location.origin
    }${portalUrl}authenticatedkeepalive.aspx?time=${new Date().getTime()}`,
    {
      method: "GET",
      headers,
    },
  ).catch(() => {
    logOut();
  });
};

export const logOut = () => {
  window.location.href = config.urlRoot + "/logout";
};
